import UpdateCampaignFieldMappingRequestModelBase from '../_generated/modelBases/update-campaign-field-mapping-request-model-base';

export default class UpdateCampaignFieldMappingRequestModel extends UpdateCampaignFieldMappingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
